import React from 'react';
import PropTypes from 'prop-types';
import { validFileTypes } from '../../../../../util/file-helpers';
import "./DisplayAlert.scss";

const DisplayAlert = ({ showAlert, alertMessage, sizeExceeded = "", customAlert = false }) => {
    if (!showAlert) return null;

    const validFileTypesMessage = validFileTypes.map(type => `${type}`).join(', ');

    return (
        <div className="invalid-file">
            <div className="invalid-attachment-icon"></div>
            {   !customAlert && alertMessage !== "File type is not supported" ?
                    <p className="file-size-invalid">{`${
                        sizeExceeded === "10MB"
                            ? `File image size must be under: 10MB`
                            : `File size must be under: 50MB`
                    }`}</p>
                :
                    <p>File format must be {validFileTypesMessage}</p>
            }
            {
                customAlert &&
                <p>{alertMessage}</p>
            }
        </div>
    );
};

DisplayAlert.propTypes = {
    showAlert: PropTypes.bool.isRequired,
    alertMessage: PropTypes.string.isRequired,
    sizeExceeded: PropTypes.oneOf(["","10MB", "50MB"]),
    customAlert: PropTypes.bool
};

export default DisplayAlert;
